export default "__VITE_ASSET__nFHF903x__"